export var getVariantPath = function getVariantPath(_ref) {
  var id = _ref.id,
      element = _ref.element,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'element' : _ref$type;
  return function () {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'base';
    var state = arguments.length > 1 ? arguments[1] : undefined;
    var elementPath = element ? "".concat(id, ".").concat(element) : id;

    if (variant === 'base') {
      return !state ? "spark.".concat(type, ".").concat(elementPath, ".base") : "spark.".concat(type, ".").concat(elementPath, ".base.").concat(state);
    } else {
      return !state ? "spark.".concat(type, ".").concat(elementPath, ".variants.").concat(variant) : "spark.".concat(type, ".").concat(elementPath, ".variants.").concat(variant, ".").concat(state);
    }
  };
};